import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to the element named by the URL's #hash when a page mounts or the
 * hash changes. An in-app navigation doesn't do this on its own, and
 * ScrollToTop deliberately leaves hashed routes alone — so a link like
 * `/admin/events/:id#feedback` would otherwise land wherever the previous
 * page was scrolled. Call it from a page whose sections carry matching ids,
 * once those sections have rendered.
 */
export function useScrollToHash() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView();
  }, [hash]);
}
